<template>
  <div class="ef-footer py-5">
    <div class="container">
      <div class="row mb-4">
        <div class="col-md-4 mb-3">
<!--          <img class="ef-footer-logo mb-4" src="../assets/images/ef-footer-logo.png" alt="EliteFit">-->
          <div class="ef-footer-logo mb-4">
            <img src="../assets/EliteFitAI-Logo.svg" alt="EliteFit"/>
            <div class="logo-text">{{t('logo-text')}}</div>
          </div>
          <div class="text-footer">{{t('text-footer-1')}}</div>
          <div class="text-footer mb-4">{{t('text-footer-2')}}</div>
          <div class="social-logo">
            <a href="https://www.facebook.com/Elitefitforyou" target="_blank">
              <img src="../module_user/assets/images/landingPage/facebook.svg" alt="Facebook"/>
            </a>
            <a href="https://www.linkedin.com/company/elitefit-ai" target="_blank">
              <img src="../module_user/assets/images/landingPage/linkedin.svg" alt="Linkedin"/>
            </a>
            <a href="https://www.youtube.com/channel/UCtFOZEYkdxcWRvGfHKIu0jQ" target="_blank">
              <img src="../module_user/assets/images/landingPage/youtube.svg" alt="YouTube"/>
            </a>
            <a href="https://www.instagram.com/elitefit.ai/" target="_blank">
              <img src="../module_user/assets/images/landingPage/Instagram.svg" alt="Instagram"/>
            </a>
          </div>
          <div class="mt-4">
            <LanguageSwitcher></LanguageSwitcher>
          </div>
        </div>

        <div class="col-md-8">
  <div class="row mt-4">
    <div class="col-6 col-md-3 mb-4">
      <h2 class="mb-4">{{ t('Who We Serve') }}</h2>
      <ul class="list-unstyled">
        <li><router-link :to="link ? '/v2/healthcare' : '/healthcare'">{{ t('Healthcare') }}</router-link></li>
        <li><router-link :to="link ? '/v2/fitness' : '/fitness'">{{ t('Fitness/Yoga') }}</router-link></li>
        <!-- <li><router-link :to="'/yoga'">{{ t('Yoga') }}</router-link></li> -->
<!--        <li><router-link :to="link ? '/sports' : '/sports'">{{ t('Sports') }}</router-link></li>-->
        <li><router-link :to="link ? '/v2/insurance' : '/insurance'">{{ t('Insurance') }}</router-link></li>
        <li><router-link :to="link ? '/v2/publicsector' : '/publicsector'">{{ t('Public Sector') }}</router-link></li>
        <!-- <li><router-link :to="'/schools'">{{ t('Schools') }}</router-link></li> -->
      </ul>
    </div>
    <div class="col-6 col-md-3 mb-4">
      <h2 class="mb-4">{{ t('About EliteFitAI') }}</h2>
      <ul class="list-unstyled">
        <!-- <li><router-link :to="'/coaches'">{{ t('Coaches') }}</router-link></li>
        <li><router-link :to="'/distributors'">{{ t('Distributors') }}</router-link></li> -->
        <!-- <li><router-link :to="'/corporate'">{{ t('Corporate') }}</router-link></li> -->
        <li><router-link :to="link ? '/v2/our-journey' : '/our-journey'">{{ t('Why EliteFitAI') }}</router-link></li>
        <li><router-link :to="link ? '/v2/careers' : '/careers'">{{ t('Careers') }}</router-link></li>
        <li><router-link :to="link ? '/v2/contact-us' : '/contact-us'">{{ t('Contact Us') }}</router-link></li>
      </ul>
    </div>
    <div class="col-6 col-md-3 mb-4">
      <h2 class="mb-4">{{ t('Resources') }}</h2>
      <ul class="list-unstyled">
        <li><router-link :to="link ? '/v2/videos' : '/videos'">{{ t('Videos') }}</router-link></li>
        <li><router-link :to="link ? '/v2/press' : '/press'">{{ t('Press & Media') }}</router-link></li>
        <li><a :href="isPhysio ? 'https://help.elitefitforyou.com/FAQs/FAQs1?role=physio' : 'https://help.elitefitforyou.com/FAQs/FAQs1?role=fitness'" target="_blank">{{ t('FAQs') }}</a></li>
      </ul>
    </div>
    <div class="col-6 col-md-3 mb-4">
      <h2 class="mb-4">{{ t('Legal') }}</h2>
      <ul class="list-unstyled">
        <li><router-link :to="'/terms-of-use'">{{ t('Terms of Use') }}</router-link></li>
        <li><router-link :to="'/privacy-policy'">{{ t('Privacy Policy') }}</router-link></li>
        <li><router-link :to="'/cookie-policy'">{{ t('Cookies & Ads') }}</router-link></li>
      </ul>
    </div>
  </div>
</div>

      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { i18nComponentMixin } from '@/i18n/mixin';

export default {
mixins:[i18nComponentMixin('components/EfFooter')],
name: "EfFooter",
  components: {LanguageSwitcher},
  props: {
    link: {type: String, default: undefined}
  },
  data () {
    return {
      isPhysio: false
    }
  },
  mounted() {
    const userInfo = this.$store.state.userInfo;
    this.isPhysio = userInfo?.corporate?.theme == "physiotherapy";
  }
}
</script>

<style lang="scss" scoped>
.ef-footer {
  background-color: #000000;
  color: #FFFFFF;
  text-align: start !important;
  font-size: 14px;
  .ef-footer-logo {
    width: fit-content;
    text-align: center;
    img {
      width: 40px;
      margin-bottom: 10px;
    }
    .logo-text {
      letter-spacing: 3px;
    }
  }
  .text-footer {
    margin-bottom: 10px;
  }
  h2 {
    font-weight: 700;
    font-size: 17px;
    color: var(--theme);
  }
  .social-logo {
    a {
      margin-right: 20px;
    }
    img {
      display: inline-block;
      height: 20px;
      width: 20px;
    }
  }
  ul {
    li {
      font-weight: 400;
      margin-bottom: 10px;
      a {
        color: #FFFFFF;
        :hover {
          color: #FFFFFF;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
